// Shared "where's the map cursor right now" state.  Set by the
// tactical map (TheCatlMap.vue) after a 300 ms mouse-stillness
// debounce; read by the status bar to render the DMM coord next
// to the AIS / STANAG badges.
//
// Deliberately null while the operator is actively panning /
// mousing so the status bar shows nothing during motion — see the
// user request that motivated this store ("avoid churn and
// computation, settling period as the mouse is moving").

import { defineStore } from 'pinia'

export interface MapCursorCoord {
    readonly lat: number
    readonly lon: number
}

export const useMapCursorStore = defineStore('mapCursor', {
    state: () => ({
        coord: null as MapCursorCoord | null,
    }),
    actions: {
        set(coord: MapCursorCoord): void {
            this.coord = coord
        },
        clear(): void {
            this.coord = null
        },
    },
})
